import { AbstractControl } from '@angular/forms';


export abstract class InputErrorService {

    abstract validarError(paso: string, campo: AbstractControl): void;
}
